import { IndicatorCodes } from '../../core/_enums/indicators.code';

export const PROJECT_STATUSES = [
  { value: 'Pending', labelKey: 'project_status_pending' },
  { value: 'Handed', labelKey: 'project_status_handed' },
  { value: 'Finished', labelKey: 'project_status_finished' },
  { value: 'Model', labelKey: 'project_status_model' }
];

export const PROJECT_STEPS = {
  PROJECT: 0,
  SOLUTION: 1,
  RESULT: 2
} as const;

export const STEP_LABELS = ['project_step_label_project', 'project_step_label_solution', 'project_step_label_result'];

export const INDICATOR_CODES_TO_DISPLAY = [IndicatorCodes.Energie, IndicatorCodes.CO2, IndicatorCodes.ReclaimedAsphalt, IndicatorCodes.NaturalAggregaes, IndicatorCodes.SoildReused, IndicatorCodes.RecycledMaterials, IndicatorCodes.TonneKilometre];
